/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import Router from "routes/Routes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import Api from "services/axios_instance";
import localStorageService from "services/localStorageService";
import { ErrorBoundary } from "react-error-boundary";
import { AUTHORIZATION_INFO } from "@pga/utils/constance/constance";
import { ClientLogs_request } from "services/errorHandling/type";
import { returnNameOfBrowser } from "@pga/utils/stringutils/stringfunctions";
import ErrorHandlingService from "services/errorHandling/services";
import { DisConnectInternet } from "pages/common/privateComponents/disconnectInternet/view";
import { TaxiSplashScreen } from "pages/common/privateComponents/taxiSplashScreen/view";

function App() {
  const CheckHealthUrl: string = process.env.REACT_APP_CHECK_HEALTH!;
  const [continueApp, setContinueApp] = useState<boolean | null>(null);
  const [exitApp, setExitApp] = useState<boolean>(false);
  const [hasInternt, setHasInternet] = useState<boolean | null>(null);

  // جهت فراخوانی اینکه آیا سرور برقرار است
  // اگر سرور برقرار باشد سیستم روتر فعال می شود
  // در صورتیکه سرور برقرار نباشد صفحه ای نمایش داده نمی شود و امکان تلاش مجدد وجود دارد
  async function fetch() {
    const response = await Api(true).get(CheckHealthUrl);
    if (response && response.status === 200) {
      setContinueApp(true);

      // set time difference:
      try {
        var date = response.headers["date"];

        var serverTime = new Date(date).getTime();
        var deviceTime = new Date().getTime();

        var timeDiff = serverTime - deviceTime; //in ms
        localStorageService.set("totalDifferenceMS", timeDiff);
      } catch (error) {
        console.log("🚀 ~ file: App.tsx ~ fetch ~ error:", error);
      }
    } else {
      setContinueApp(false);
    }
  }

  // در صورتی که در خطای کش باشد به این معنی است که سرور بالا نیست
  useEffect(() => {
    if (hasInternt) {
      try {
        // backRoute_WebView();
        fetch();
      } catch (error) {
        console.log("🚀 ~ file: App.tsx ~ useEffect ~ error:", error);
        setContinueApp(false);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }
  }, [hasInternt]);
  //-------- چک کردن اینترنت
  // و چک کزدن درایور در فقط در فلاتر کار کند
  useEffect(() => {
    try {
      if (navigator.onLine) {
        setHasInternet(true);
      } else {
        setHasInternet(false);
      }
    } catch (error) {
      console.log("🚀 ~ file: App.tsx ~ useEffect ~ error:", error);
      setContinueApp(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // جهت مدیریت کردن خطاها
  function fallbackRender({ error, resetErrorBoundary }: any) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.

    return (
      <>
        <div className="error-catch-wrap">
          <p>مشکلی به وجود آمده است!!!</p>
          <button
            className="recall-btn"
            onClick={() => window.location.reload()}
          >
            بارگذاری مجدد
          </button>
        </div>
      </>
    );
  }

  const logError = (error: Error, info: { componentStack: string }) => {
    // Do something with the error, e.g. log to an external API
    let lsData = localStorageService.get(AUTHORIZATION_INFO) || null;
    if (lsData && lsData.accessTokenExpiration) {
      const request: ClientLogs_request = {
        packageName: "",
        packageVersion: "",
        error: error.message,
        device: returnNameOfBrowser(),
        application: "SeparTa",
        path: window.location.pathname,
        stackTrace: error.stack!,
        platform: "Web",
        additionalData: error.toString(),
      };
      try {
        ErrorHandlingService.ClientLogs(request).then((res) => {});
      } catch (error) {
        console.log(
          "🚀 ~ file: error-boundary.ts ~ ErrorBoundary ~ componentDidCatch ~ error:",
          error
        );
      }
    }
  };
  return (
    <div className="App">
      {hasInternt === true && (
        <div>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={true}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
          {continueApp === null && <TaxiSplashScreen />}
          {continueApp === true && (
            <ErrorBoundary fallbackRender={fallbackRender} onError={logError}>
              <Router />
            </ErrorBoundary>
          )}
          {continueApp === false && (
            <>
              <DisConnectInternet
                description={
                  "در ارتباط شما با سرور مشکلی بوجود آمده است . لطفا اینترنت خود را بررسی کنید ."
                }
                showExitApp={exitApp}
                callBack={fetch}
              />
            </>
          )}
        </div>
      )}
      {hasInternt === false && (
        <DisConnectInternet
          description={"اینترنت شما قطع است. دوباره تلاش کنید"}
          showExitApp={exitApp}
        />
      )}
      {hasInternt === null && <TaxiSplashScreen />}
    </div>
  );
}

export default App;
